// Utils/Pdf/DeclarationPdfTemplate.jsx

import { assets } from "../../../Assets/assets";

const DeclarationPdfTemplate = ({ declaration, user }) => (
  <div
    className="max-w-3xl mx-auto bg-white border relative border-gray-200 overflow-hidden"
    style={{ minHeight: "1122px", width: "794px" }} // fixed width so off-screen render is consistent
  >
    <img src={assets.frame1} alt="" className="w-full absolute top-0 left-0" />
    <img
      src={assets.frame2}
      alt=""
      className="w-full absolute bottom-3 right-0"
    />

    <div className="px-10 pb-7 pt-12 flex justify-between border-b items-center">
      <img src={assets.qqtlogo} alt="" className="w-36" />
      <div className="text-right text-sm leading-tight">
        <div>+91 833 990 3307</div>
        <div>support@pcmexports.com</div>
      </div>
    </div>

    <div className="px-12 py-10 text-[15.2px] flex flex-col justify-between h-[60rem] leading-relaxed text-gray-800">
      <div>
        <div className="text-center mb-10">
          <h1 className="text-4xl font-thin font-serif text-red-700">
            Declaration
          </h1>
          <div className="w-24 h-0.5 bg-red-200 mx-auto mt-3"></div>
        </div>

        <p className="mb-10">
          {declaration.reason || "This declaration does not contain a reason."}
        </p>

        {declaration.declaration_contents?.length > 0 && (
          <div className="space-y-5 mb-12">
            {declaration.declaration_contents.map((item, idx) => (
              <div key={idx} className="flex gap-4">
                <div
                  className={`w-7 h-7 rounded-lg border-2 flex-shrink-0 flex items-center justify-center mt-0.5
                  ${item.isChecked ? "bg-green-100 border-green-600" : "border-gray-300"}`}
                >
                  {item.isChecked && (
                    <span className="text-green-600 text-xl">✓</span>
                  )}
                </div>
                <p className="pt-1">{item.content}</p>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="mt-16">
        <div className="flex justify-between items-end">
          <div className="text-center">
            {user?.profilePic ? (
              <div className="w-24 h-24 rounded-2xl overflow-hidden border border-gray-200 shadow-sm bg-white mx-auto mb-3">
                <img
                  src={user.profilePic}
                  alt="Company Logo"
                  className="w-full h-full object-cover"
                />
              </div>
            ) : (
              <div className="w-24 h-24 mx-auto rounded-2xl border border-dashed border-gray-300 flex items-center justify-center text-gray-400 text-xs mb-3">
                No Logo
              </div>
            )}
            <p className="font-semibold text-base">
              {user?.companyName || "Unknown Company"}
            </p>
            <p className="text-sm text-gray-500 mt-1">Company / Profile</p>
          </div>

          <div className="text-center">
            {declaration.e_sign ? (
              <div className="mb-4 border-b border-gray-400 pb-3">
                <img
                  src={declaration.e_sign}
                  alt="E-Signature"
                  className="h-24 -mb-9 mix-blend-multiply mx-auto object-contain"
                />
              </div>
            ) : (
              <div className="h-24 w-64 border border-dashed border-gray-300 flex items-center justify-center text-gray-400 mb-4">
                No Signature
              </div>
            )}
            <p className="font-semibold text-xl">
              {user?.firstName} {user?.lastName}
            </p>
            <p className="text-sm text-gray-500 mt-1">Authorised Signatory</p>
          </div>
        </div>

        <div className="py-5 px-10 text-center text-xs text-gray-500 border-t mt-4">
          POWERED BY PCM EXPORTS • Declared on:{" "}
          {new Date(declaration.createdAt).toLocaleDateString("en-IN", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </div>
      </div>
    </div>
  </div>
);

export default DeclarationPdfTemplate;
